import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "OrderPartListPage" */
	'pages/supplier/OrderPart/OrderPartListPage'));

export default [{ component, exact: true, path: '/order_parts' }];